import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeatureShowcase from "./components/FeatureShowcase";
import AboutSection from "./components/AboutSection";
import ComparisonTable from "./components/ComparisonTable";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />

      <main>
        {/* Hero */}
        <HeroSection />

        {/* Value Proposition */}
        <section className="py-14 md:py-18 px-6 md:px-10 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              Why <span className="italic text-primary-500">GTBuy Spreadsheet</span>?
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-8">
              GTBuy Spreadsheet is a next-generation spreadsheet system designed for users who manage product sourcing through platforms like Kakobuy and Superbuy. It helps you track product orders in real-time, compare suppliers and pricing, automate spreadsheet workflows, reduce manual data entry errors, and scale sourcing operations efficiently.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-foreground-500">
              {[
                "Track product orders in real-time",
                "Compare suppliers and pricing",
                "Automate spreadsheet workflows",
                "Reduce manual data entry errors",
                "Scale sourcing operations efficiently",
              ].map((item) => (
                <span
                  key={item}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800"
                >
                  <i className="ri-check-line text-accent-500"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* Category Grid */}
        <CategoryGrid />

        {/* Feature Showcase */}
        <FeatureShowcase />

        {/* About Section */}
        <AboutSection />

        {/* Comparison Table */}
        <ComparisonTable />

        {/* Trust Section */}
        <section className="py-12 px-6 md:px-10 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-accent-500"></i>
                Secure spreadsheet handling
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-lock-line text-accent-500"></i>
                No data selling
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-global-line text-accent-500"></i>
                GDPR compliant
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-key-2-line text-accent-500"></i>
                Encrypted workflow system
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line text-accent-500"></i>
                Transparent data usage policy
              </span>
            </div>
          </div>
        </section>

        {/* Testimonial */}
        <TestimonialSection />

        {/* CTA */}
        <CTASection />

        {/* FAQ */}
        <FAQSection />

        {/* Article Link Section */}
        <section className="py-14 px-6 md:px-10 bg-background-50">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              Learn More About GTBuy Spreadsheet
            </h2>
            <p className="text-sm text-foreground-500 mb-6 max-w-lg mx-auto">
              Dive deeper into how the GTBuy Spreadsheet system works, from setup to advanced automation techniques.
            </p>
            <Link
              to="/article/gtbuy-spreadsheet-guide"
              className="inline-flex px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Read the Full Guide &rarr;
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}